import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles((theme:any) => ({
    menuPaper: {
      maxHeight: 300
    }
  }));